import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../Base/Services/Language/LanguageService";
import Card from "../../Base/Components/Card/Card";
import { ConfigContext } from "../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../Base/Lang/BaseLang";
import { setTitlePage } from "../../Base/Services/Config/ConfigService";
import Loader from "../../Base/Components/Loader/Loader";
import AgGrid from "../../Base/Components/Tables/AgGrid/AgGrid";
import { toastShow } from "../../Base/Services/ToastService";
import { getEstadosCategoryIPS } from "../../Base/API/Global/Estados/StatusRequest";

import { AgregarHilaza, CambiarEstado, getHilaza, getYarn } from "../../API/Desarrollo/DesarrolloRequest";


const HilazaScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [detalles, setDetalles] = useState([]);
  const [showDialog, setShowDialog] = useState(false);;
  const [selected, setSelected] = useState(null)
  const [yarnDev, setYarnDev] = useState([])
  const [estados, setEstados] = useState([])

  const getInfo = async () => {
    setLoading(true);

    const result = await getHilaza()
    setDetalles(result)

    const yarnDevTempo = await getYarn()
    setYarnDev(yarnDevTempo)

    const estadosTempo = await getEstadosCategoryIPS('Customer')
    setEstados(estadosTempo?.filter(i => i.IdStatus === 1 || i?.IdStatus === 2))

    setLoading(false);
  };

  const changeYarnDev = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={yarnDev.find((e) => e.IdYarnTitle === data?.IdYarnDev)}
          options={yarnDev}
          style={{ width: "100%", position: "relative" }}
          optionLabel="Yarn"
          filter
          filterBy="Yarn"
          showClear
          clearIcon="pi pi-times"
          className="custom-dropdown"
          onChange={(e) => {
            confirmDialog({
              message: e?.value ? "¿Desea agregar la Hilaza?" : "¿Desea eliminar la Hilaza?",
              header: e?.value ? "Agregar Hilaza" : "Eliminar Hilaza",
              icon: "pi pi-exclamation-triangle",
              acceptLabel: "Sí",
              rejectLabel: "No",
              style: { backgroundColor: "white" },
              accept: () => {
                let IdProductoSuministro = data?.IdProductoSuministro;
                let IdYarnTitle = e.value?.IdYarnTitle;
                const result = AgregarHilaza(IdProductoSuministro, IdYarnTitle);
                if(result){
                    toastShow(toast, "success", "Hilaza agregada correctamente");
                    getInfo();
                    // let tempo2 = [...detalles];
                    // const index = detalles.findIndex(
                    //   (detail) =>
                    //     detail.IdProductoSuministro === data.IdProductoSuministro
                    // );
                    // tempo2[index].IdYarnDev = e.value.IdYarnDev;
                    // tempo2[index].Yarn = e.value.Yarn;
                    // setDetalles(tempo2);
                }else{
                    toastShow(toast, "error", "Error al agregar la Hilaza");
                }
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const changeEstado = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={estados.find((e) => e.IdStatus === data?.IdEstado)}
          options={estados}
          style={{ width: "100%", position: "relative" }}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          clearIcon="pi pi-times"
          onChange={(e) => {
            confirmDialog({
              message: "¿Desea cambiar el estado de la Hilaza?",
              header: "Cambiar Estado",
              icon: "pi pi-exclamation-triangle",
              acceptLabel: "Sí",
              rejectLabel: "No",
              style: { backgroundColor: "white" },
              accept: () => {
                setLoading(true)
                let IdProductoSuministro = data?.IdProductoSuministro;
                let IdEstado = e.value?.IdStatus;
                const result = CambiarEstado(IdProductoSuministro, IdEstado);
                if(result){
                  toastShow(toast, "success", 'Cambiado',"Estado cambiado exitosamentee");
                  let tempo2 = [...detalles];
                  const index = detalles.findIndex((detail) => detail.IdProductoSuministro === data.IdProductoSuministro);
                  tempo2[index].IdEstado = e.value.IdStatus;
                  tempo2[index].Estado = e.value.StatusName;
                  setDetalles(tempo2);
                }else{
                  toastShow(toast, "error", "Error al cambiar estado de la Hilaza");
                }
                setLoading(false)
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const colums = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdProductoSuministro',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "Estado",
      header: "Estado",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.Estado }),
      Format: "Estado",
      editable: true,
      cellEditor: changeEstado,

    },
    {
      header: 'Código',
      headerEn: 'Code',
      field: 'CodigoProducto',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'small',
      frozen: true,
      Format: 'Modal',
      Sumary: 'count',
    },
    {
      header: 'Hilaza',
      headerEn: 'Yarn',
      field: 'NombreProducto',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'XXXlarge',
    },
    {
      header: 'Categoría',
      headerEn: 'Category',
      field: 'Categoria',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xsmall',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'DescripcionProducto',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xlarge',
    },
    {
      field: 'Yarn',
      header: 'Hilaza Dev',
      headerEn: 'Yarn Dev',
      className: "XXXlarge",
      editable: true,
      cellEditor: changeYarnDev,
    },
    {
      header: 'Origen',
      headerEn: 'Origin',
      field: 'SubCategoria',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xsmall',
    },
    {
      header: 'Unidad',
      headerEn: 'Unit',
      field: 'Unidad',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xsmall',
    },
    {
      header: 'Moneda',
      headerEn: 'Currency',
      field: 'Moneda',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xsmall',
    },
    {
      header: 'Inventario',
      headerEn: 'Inventory',
      field: 'QtyInventory',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true)
        setSelected(data);
      },
      className: 'Xsmall',      
      frozen: true,
      alignFrozen: "right",
      Format: 'Currency',
      Sumary: 'sum',
    },
  ]

  const table = {
    Columns: colums,
    Data: detalles,
  }


  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Hilaza", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "Hilaza", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />
            <ConfirmDialog />

            <div style={{ height: '83vh' }}>
                <AgGrid table={table} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default HilazaScreen;
